module.exports = require("@angular/cdk/overlay");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/overlay"
// module id = 998
// module chunks = 0